import React from "react";
import { TCText } from "../../../components/tcText/TCText";

type props = {
  children: React.ReactNode;
  title: string;
};

export const SectionBackground: React.FC<props> = ({ children, title }) => {
  return (
    <div
      style={{
        height: "100%",
        backgroundColor: "white",
        borderRadius: 20,
        padding: 20,
      }}>
      <TCText
        style={{ fontWeight: 600, textAlign: "center", fontSize: 14 }}
        value={title}
      />
      {children}
    </div>
  );
};
